var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-input-base-select',{attrs:{"options":_vm.options,"value":_vm.value,"is-list":"","icon":"document"},on:{"change":_vm.changeHandler,"focus":_vm.focusHandler,"blur":_vm.blurHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }